import { render, staticRenderFns } from "./addModal.vue?vue&type=template&id=5fa29d68&scoped=true&"
import script from "./addModal.vue?vue&type=script&lang=js&"
export * from "./addModal.vue?vue&type=script&lang=js&"
import style0 from "./addModal.vue?vue&type=style&index=0&id=5fa29d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa29d68",
  null
  
)

export default component.exports